module.exports = __webpack_public_path__ + "static/media/bg-1200.271d969c.png";